import React from 'react';
import PageLayout from '../../layout/PageLayout';
import NmckMedicinesCalculation from '../../layout/NmckGroup/NmckMedicinesCalculation';

const NmckMedicinesCalculationPage: React.FC = () => (
  <PageLayout>
    <NmckMedicinesCalculation />
  </PageLayout>
);

export default NmckMedicinesCalculationPage;
